var _path, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAiSpark = function SvgAiSpark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#4D5A6A",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200-280v80-560zm480 160H280q-66 0-113-47t-47-113v-400q0-66 47-113t113-47h201v80H280q-33 0-56.5 23.5T200-680v400q0 33 23.5 56.5T280-200h400q33 0 56.5-23.5T760-280v-201h80v201q0 66-47 113t-113 47m60-440q-6 0-8-6-16-61-60.5-105.5T566-732q-6-2-6-8 0-7 6-8 61-16 105.5-60.5T732-914q2-6 8-6t8 6q16 61 60.5 105.5T914-748q6 1 6 8 0 6-6 8-61 16-105.5 60.5T748-566q-1 6-8 6"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: -420,
    dominantBaseline: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 440,
    fontWeight: 700,
    letterSpacing: -20,
    textAnchor: "middle"
  }, "\n        AI\n    ")));
};
export default SvgAiSpark;